<div class="offlineErrorBanner">
    <div class="bannerContainer" [ngClass]="{'visible' : showBanner}">
        <div class="banner">
            <div class="message">
                <p *ngIf="isOnline">{{'FOC.DESKTOP.OFFLINE_ERROR_MODAL.ONLINE_MESSAGE' | translate }}</p>
                <p *ngIf="!isOnline">{{'FOC.DESKTOP.OFFLINE_ERROR_MODAL.OFFLINE_MESSAGE' | translate }}</p>
            </div>
            <i class="closeBanner close-icon nemo-close-new nemo-font" aria-hidden="true" (click) = "showBanner = false"></i>
    </div>
</div>